export const setProjects=(projectlist)=>{
    return {
        type:"FETCH_PROJECT_LIST",
        payload: projectlist
    }
}
